import {
    createSlice,
} from '@reduxjs/toolkit'

const initialState = {
    pageStates: []
}

const navSlice = createSlice({
    name: 'nav',
    initialState,
    reducers: {
        clearPageStates(state, action) {
            state.pageStates.length = 0
        },
        updatePageState(state, action) {
            if (state.pageStates.length === 0) {
                state.pageStates.push(action.payload)
            } else {
                const idx = state.pageStates.find(f => f.id === action.payload.id)
                if (idx === -1) {
                    state.pageStates.push(action.payload)
                } else {
                    state.pageStates.splice(idx, 1, action.payload)
                }
            }
        },
        addPageState(state, action) {
            state.pageStates.push(action.payload)
        },
        removePageState(state, action) {
            const idx = state.pageStates.find(f => f.id === action.payload)
            if (idx !== -1) {
                state.pageStates.splice(idx, 1)
            }
        },
    },
})

export const {
    clearPageStates, updatePageState, addPageState, removePageState
} = navSlice.actions
export const navPageStates = (state) => state.nav.pageStates

export default navSlice.reducer
